var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","color":"black","open-delay":"500"},scopedSlots:_vm._u([{key:"activator",fn:function({ on:tooltip, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),{...tooltip}),[_vm._t("default")],2)]}}],null,true)},[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }